import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ValidateIncentiveCode from "./pages/ValidateIncentiveCode";
import SalesInProgress from "./pages/SalesInProgress";
import ReimbursementRequest from "./pages/ReimbursementRequest";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Account from "./pages/Account";
import ContactUs from "./pages/ContactUs";
import FAQs from "./pages/FAQs";
import "./App.css";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
        },
      }}
    >
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* Placeholder routes for other pages */}
            <Route path="/validate" element={<ValidateIncentiveCode />} />
            <Route path="/sales" element={<SalesInProgress />} />
            <Route path="/reimbursement" element={<ReimbursementRequest />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/users" element={<Users />} />
            <Route path="/account" element={<Account />} />
            <Route
              path="/faqs"
              element={<FAQs />}
            />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;
